import React from 'react';
import { toast } from 'react-toastify';
import { Input } from '@progress/kendo-react-inputs';
import services from '../../services';
import { Button } from '@progress/kendo-react-buttons'
var moment = require('moment')

class BoletimModalCastas extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: {},
            telkikTable: "",
            Comment: '',
            moduleData: []
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.setMainState()
    }
    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            this.setMainState()
        }
    }
    setMainState = () => {
        // console.log(this.props);

        this.setState({
            data: this.props.data ? this.props.data : {},
            moduleData: this.props.moduledata
        }, () => {
            if (this.props.tab === 'boletimCastas') {
                this.updatePctCasta()
            }
        });
    }

    updatePctCasta = () => {
        // para atualizar o valor da porcentagem de casta
        let data = { ...this.state.data }
        let totalCasta = 0
        if (this.state.moduleData.length > 0) {
            this.state.moduleData.map(_r => {
                totalCasta += Number(_r.pctCasta)
            })
            data['pctCasta'] = 100 - totalCasta
        }
        this.setState({
            data
        })
    }

    handleDate = (e) => {
        let data = { ...this.state.data }
        data['startDate'] = e && e._d && moment(e._d).format('MM-DD-YYYY')
        this.setState({
            data
        })
    }

    handleChange = (e) => {
        let data = { ...this.state.data }
        if (e.target.name === 'pctCasta' && (Number(e.target.value) < 0 || Number(e.target.value) > 100)) {
            toast.error("A Porcentagem nunca deve ser menor que 0 ou maior que 100")
            return;
        }
        if (!e.target.value) {
            delete data[e.target.name]
        } else
            data[e.target.name] = e.target.value;

        this.setState({
            data
        })
    }

    Submitform = () => {
        let data = { ...this.state.data }
        let error = null;

        if (this.props.moduledata) {
            let index = (this.state.moduleData).length
            let dataarray = [...this.state.moduleData];
            dataarray[index] = data;
            // console.log('this data:', data);
            if (this.props.tab == "boletimCastas") {
                if (!data.pctCasta || !data.codCasta || !data.idSinonimo) {
                    toast.error("Por favor, preencha os detalhes completos");
                    return
                }
                if (dataarray.filter(_ar => _ar.codCasta == data.codCasta).length > 1) {
                    toast.error("Existe um registo associado com os dados introduzidos");
                    return
                }
                if (data.pctCasta) {
                    let castasum = 0;
                    dataarray.map((_row, index) => {
                        castasum += parseInt(_row.pctCasta)
                    });
                    if (castasum > 100) {
                        toast.error("O valor total de castas não poderá ser superior a 100%")
                        return false;
                    }
                }
                // data.fatorCasta=1;
                // data.fatorDOPorto=1;

            }
            if (!error)
                this.props.getpopUpdata(dataarray, this.props.tab);
            else
                services.errorCheck.error(error);

        } else {

            this.props.getpopUpdata(data, this.props.tab);
        }
        if (!error)
            this.props.closePopup();
    }


    /* Obter a chave do filtro do filtro personalizado */
    getFilters = () => {
        return null;
    }

    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {

    }

    handleComment = (e) => {
        this.setState({
            Comment: e.target.value
        })
    }

    handleChangeCasta = (e) => {
        let data = { ...this.state.data }
        data[e.target.name] = e.target.value;
        let Duro = {};
        let Casta = {};
        this.props.all_list.DouroPort.map((_row, index) => {
            if (parseInt(_row.duroid) === parseInt(e.target.value)) {
                Duro = _row
            }
        })
        this.props.all_list.Casta.map((_row, index) => {
            if (parseInt(_row.codcasta) === parseInt(data.codCasta)) {
                Casta = _row
            }
        })
        if (Casta.doporto == Casta.dodouro) {
            data.douroPort = Casta.doporto;
        }
        data.status = "A";
        data.dtAct = Casta.dtact;
        data.hrAct = Casta.hract;
        data.usr = Casta.usr;
        data.wks = Casta.wks;
        data.idCor = Casta.idcor;
        data.idSinonimo = Duro.idsinonimo;
        data.st = Casta.st;
        data.disponivel = true;
        data.fatorDOPorto = Casta.fatorDOPorto || 1;
        data.fatorCasta = Casta.fatorCasta || 1;
        ///Not clear
        data.tipo = this.state.data.douroPort;
        data.predioarranque = "N/A";
        data.tipoha = "N/A";

        this.setState({
            data
        });
    }

    handleAuditSubmit = () => {
        if (this.props.handleAuditSubmit) {
            this.props.handleAuditSubmit(this.state.Comment)
            this.props.closePopup()
        }
    }



    /*  Para renderizar o conteúdo html da página   */

    render() {

        if (this.props.tab === "boletimCastas" ) {
            return (
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title pl-0">Gerir Castas</h4>
                        <Button onClick={() => this.Submitform()} primary={true} className="btn-ivdp-primary btn-sm text-uppercase mr-3">Guardar</Button>
                        <Button onClick={() => this.props.closePopup()} className="remoove cursor-pointer mr-2 k-primary btn-ivdp-secondary btn-theme">Cancelar</Button>
                    </div>
                    <div className="modal-body">
                        <div className="details">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-box active-grey mb-2">
                                        <label className="input-label">Casta</label>
                                        <select className="custome-drop-down" value={this.state.data.codCasta || ""} name="codCasta" onChange={(e) => this.handleChangeCasta(e)}>
                                            <option value="">Selecione casta </option>
                                            {
                                                this.props.all_list.Casta &&
                                                this.props.all_list.Casta.map((_row, index) => (
                                                    <option value={_row.codcasta}>{_row.descasta}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label>Tipo Casta</label>
                                    <div className="input-box active-grey">
                                        <span>
                                            {
                                                this.state.data.douroPort == 'N' ?
                                                    <strong>Douro : N</strong>
                                                    :
                                                    this.state.data.douroPort == 'S' ?
                                                        <strong>Porto : S</strong>
                                                        :
                                                        ''
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-box active-grey mb-2">
                                        <label className="input-label">Cor</label>
                                        <select className="custome-drop-down" value={this.state.data.idCor || ""} name="idcor" onChange={(e) => this.handleChange(e)}>
                                            <option disabled value="">Selecione Cor</option>
                                            {
                                                this.props.all_list.colors &&
                                                this.props.all_list.colors.map((_row, index) => (
                                                    <option value={_row.idcor} disabled>{_row.descor}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-box active-grey mb-2">
                                        <label className="input-label">Sinónimos</label>
                                        <select className="custome-drop-down" value={this.state.data.idSinonimo || ""} name="idSinonimo" onChange={(e) => this.handleChange(e)}>
                                            <option value="">Selecione Sinónimos </option>
                                            {
                                                this.props.all_list.Sinonimo &&
                                                this.props.all_list.Sinonimo.map((_row, index) => (
                                                    <option value={_row.idsinonimo}>{_row.descasta}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box active-grey mb-2">
                                        <Input
                                            type="number"
                                            style={{ width: "100%" }}
                                            min={0}
                                            className="input-1"
                                            name="pctCasta"
                                            value={this.state.data.pctCasta || ""}
                                            label="Percentagem"
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box active-grey mb-2">
                                        <Input
                                            type="number"
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="fatorCasta"
                                            readOnly={true}
                                            value={this.state.data.fatorCasta || 1}
                                            label="Fator Castas"
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="input-box active-grey mb-2">
                                        <Input
                                            type="number"
                                            style={{ width: "100%" }}
                                            className="input-1"
                                            name="fatorDOPorto"
                                            label="Fator DO Porto"
                                            readOnly={true}
                                            value={this.state.data.fatorDOPorto || 1}
                                            onChange={(e) => this.handleChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
       
    }
}

export default BoletimModalCastas;